'use strict';

angular.module('msCore').service('notificationSvc', ['httpSvc', function (httpSvc) {
  var cb;

  function _registerRefreshCallback(callback) {
    cb = callback;
  }

  function _refresh() {
    if (angular.isFunction(cb)) {
      cb();
    }
  }

  function _getNotificationsByStatus(status) {
    return httpSvc.get('/apiproxy/user/notification/status/' + status);
  }

  /**
   * Called to update the status of an existing notification (i.e. NEW to READ)
   * @param notification JSON of the notification to change
   * @param status the updates status to assign to this notification
   */
  function _changeNotificationStatus(notificationList, status) {
    if (!_.isArray(notificationList)) {
      throw new Error('Must pass list as param');
    }
    return httpSvc.put('/apiproxy/user/notification/status/' + status, notificationList);
  }

  return {
    getNotificationsByStatus: _getNotificationsByStatus,
    changeNotificationStatus: _changeNotificationStatus,
    registerRefreshCallback: _registerRefreshCallback,
    refresh: _refresh
  };
}]);